// Types
import { Place } from '../../../server/src/types/place.types';

import { sortByComparators } from 'utils/sortByComparators';

export const sortPlaces = (
  places: Place[] | undefined,
  sortBy: string
): Place[] => {
  return sortByComparators(places, sortBy, {
    naziv: (a, b) => a.name!.localeCompare(b.name!),
    'naziv-desc': (a, b) => b.name!.localeCompare(a.name!),
    datum: (a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    'datum-desc': (a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  });
};
